import React from "react";

import { Row, Col } from "react-bootstrap";

import PageTitleNew from "../../../ui/PageTitleNew";

import { useEditCoachPoolContext } from "../../../../contexts/EditCoachPoolContext";

export default function Form() {
  const { dispatch, actions, state } = useEditCoachPoolContext();

  const editCoachPool = () => {
    actions.editCoachPool(state.coachPool.id);
  };

  return (
    <>
      <PageTitleNew
        title={`View Coach Pool - ${state.coachPool.attributes.name}`}
      />

      <div className="ibox-content mt20">
        <Row>
          <Col md={6}>
            {state.coaches != null && (
              <div className="mt10">
                Number of Coaches: {state.coachSelected.length} of{" "}
                {state.coaches.length}
              </div>
            )}

            {state.coachPool.attributes.default && (
              <div>Default Pool (Assign to all new Teams automatically)</div>
            )}
          </Col>
          <Col className="text-right" md={6}>
            <a className="btn btn-green w-150" onClick={editCoachPool}>
              Edit Pool
            </a>
          </Col>
        </Row>
      </div>
    </>
  );
}
